module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-item"
  }, [_c('div', {
    staticClass: "row row_com_mo",
    staticStyle: {
      "margin-left": "0px"
    }
  }, [_c('div', {
    staticClass: "col-md-2 col-xs-2 big_icon_com_mo",
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('div', {
    staticClass: "img-format"
  }, [_c('img', {
    staticClass: "img_com",
    attrs: {
      "src": _vm.o && _vm.o.banner && _vm.o.banner[0]
    }
  })])]), _c('div', {
    staticClass: "col-md-1 col-xs-1 icon_com_mo"
  }, [_c('div', {
    staticClass: "icon-div"
  }, [_c('img', {
    staticClass: "img_com",
    attrs: {
      "src": _vm.o.icon
    }
  })])]), _c('div', {
    staticClass: "col-md-9 col-xs-9 text_com_mo",
    staticStyle: {
      "font": "Bold 17px/21px Proxima Nova",
      "letter-spacing": "0px",
      "color": "#4B2D15"
    }
  }, [_vm._v(_vm._s(_vm.o.name))])]), _c('div', {
    staticClass: "row row_com_mo",
    staticStyle: {
      "margin-left": "0px"
    }
  }, [_c('div', {
    staticClass: "col-md-2 col-xs-2"
  }), _c('div', {
    staticClass: "col-md-1 col-xs-1 icon_com_mo"
  }, [_c('img', {
    staticClass: "img_com",
    attrs: {
      "src": _vm.o.user ? _vm.o.user.avatar : ''
    }
  })]), _c('div', {
    staticClass: "col-md-9 col-xs-9 text_com_mo",
    staticStyle: {
      "font": "Regular 15px/18px Proxima Nova",
      "letter-spacing": "0px",
      "color": "#9F6A28"
    }
  }, [_vm._v(_vm._s(_vm.o.user ? _vm.o.user.fullname : ''))])]), _c('div', {
    staticClass: "row row_com_mo",
    staticStyle: {
      "margin-left": "0px"
    }
  }, [_c('div', {
    staticClass: "col-md-2 col-xs-2"
  }), _vm._m(0), _c('div', {
    staticClass: "col-md-4 col-xs-4 text_com_mo",
    staticStyle: {
      "font": "Regular 13px/16px Proxima Nova",
      "letter-spacing": "0px",
      "color": "#3A9F00"
    }
  }, [_vm._v(_vm._s(_vm.o.subject ? _vm.o.subject.name : ''))]), _vm._m(1), _c('div', {
    staticClass: "col-md-4 col-xs-4 text_com_mo",
    staticStyle: {
      "font": "Regular 13px/16px Proxima Nova",
      "letter-spacing": "0px",
      "color": "#4B2D15"
    }
  }, [_vm._v(_vm._s(_vm.messageText))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-1 col-xs-1 icon_com_mo"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/community/ic_khoilop.svg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-1 col-xs-1 icon_com_mo"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/community/ic_thanhvien.svg")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fe902aa6","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserProfile/CommunityItem.vue
// module id = 1671
// module chunks = 0